export default class Formation {

    constructor() {
        this.addEvents();
    }

    addEvents() {
        function checkmail(el){
            if (!/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/.test(el)) {
                return false
            } else {
                return true
            }
        }

        jQuery(document).ready(function($) {
            $('.formation24__play').on('click', function (e){
                e.preventDefault();
                $('.formation24__popup').addClass('active');
            })

            $('.formation24__rgba').on('click', function (e){
                e.preventDefault();
                $('.formation24__popup').removeClass('active');
            })

            $('.formation24__close').on('click', function (e){
                e.preventDefault();
                $('.formation24__popup').removeClass('active');
            })

            $('.formation24__btn').on('click', function (e) {
                e.preventDefault();
                let error = 0;
                let firstname = $('.formation24__form--first');
                let lastname = $('.formation24__form--last');
                let email = $('.formation24__form--email');
                let job = $('.formation24__form--job');
                let company = $('.formation24__form--company');

                if(firstname.val().length >=3){
                    firstname.removeClass('error');
                }else{
                    firstname.addClass('error');
                    error++;
                }

                if(checkmail(email.val())){
                    email.removeClass('error');
                }else{
                    email.addClass('error');
                    error++;
                }

                if(lastname.val().length >=3){
                    lastname.removeClass('error');
                }else{
                    lastname.addClass('error');
                    error++;
                }

                if(job.val().length >=3){
                    job.removeClass('error');
                }else{
                    error++;
                    job.addClass('error');
                }

                if(company.val().length >=3){
                    company.removeClass('error');
                }else{
                    error++;
                    company.addClass('error');
                }

                if(error == 0) {
                    var ajaxurl = '/wp-admin/admin-ajax.php';
                    $.ajax({
                        type: "POST",
                        url: ajaxurl,
                        data: {
                            "ip": $('.formation24').attr('data-ip'),
                            "first_name": firstname.val(),
                            "last_name": lastname.val(),
                            "email": email.val(),
                            "job": job.val(),
                            "company": company.val(),
                            "action": "add_ip",
                        },
                        success: function (result) {
                            window.location.reload();
                        }
                    });
                }
            });

        })
    }

}